import script from "./esFinancialChannelSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esFinancialChannelSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esFinancialChannelSettings.vue?vue&type=style&index=0&id=9bce6880&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bce6880"]])

export default __exports__